// import Vue from 'vue'

import request from "./config/http.js";
import params from "./config/params.js";
import HTTP from "./config/listGIt.js";
const URL3 = "https://zwi.cnknowledge.com/api";//正式
const URL4 = "https://wxtest.cnknowledge.com/api";//测试
const URL5 = "https://zwiii.cnknowledge.com/api";//预发布
//https://zwi.cnknowledge.com/api/zw-chat/editing_index/detail?editId=1460515768465756160&perId=1316247169054867456
//http://112.126.62.200:5052/api/zw-chat/editing_index/detail?editId=1446352177927950336&perId=1297783010043576320&userId=1460447571230199808&username=18434816689&timestamp=1646360495000
//http://112.126.62.200:5052/api/zw-user/nf/getloginInfo
//https://zwi.cnknowledge.com/api/zw-user/nf/getloginInfo

import axios from "axios";
let getAuthorUrl = () => {
  let url = "";
  if (
    location.host.indexOf("cbtest.") != -1 ||
    location.host.indexOf(":80") != -1 ||
    location.host.indexOf("localhost") != -1
  ) {
    url = URL4; // 投审稿作者端测试环境
  } else if (location.host.indexOf("yucard") != -1) {
    url = URL5; // 投审稿作者端预生产环境
  } else {
    url = URL3; // 投审稿作者端正式环境
  }
  return url;
};

const BASE_URL = getAuthorUrl();
let dev = "/tsg-author";
const apis = {
  /** 获取聊天内容
   * @param { String } groupId 聊天组id
   * @param { Number } pageNo  页数
   * @param { Number } pageSize  每页条数
   */
  getChatContent(params) {
    return HTTP.get(BASE_URL + "/zw-chat/chat/getChatPage", params, false);
  },

  /** 获取聊天组id
   * @param { String } perId 期刊id
   * @param { String } reciveId 接受者id
   * @param { String } sendId 发送者id
   */
  getChatId(params) {
    return HTTP.get(BASE_URL + "/zw-chat/chat/getGroupId", params, false);
  },

  /** 获取名片列表
   * @param { String } userId  用户id
   */
  getCardList(params) {
    return HTTP.get(
      BASE_URL + "/zw-chat/editing_center/cardHolder",
      params,
      false
    );
  },

  /** 我的名片列表
   * @param { String } userId 用户id
   */
  getMyCard(params) {
    return HTTP.get(BASE_URL + "/zw-chat/myCard/list", params, false);
  },
};
export default apis;
